/** OKLCH gradient used for prediction-error row backgrounds + mini-chart line. */

export function errorRowBackground(errorAbs: number | null | undefined): string | undefined {
  if (errorAbs === null || errorAbs === undefined || !Number.isFinite(errorAbs)) {
    return undefined;
  }
  const e = Math.abs(errorAbs);
  // 0 -> green (145), 5 -> orange (35), 10+ -> red (0)
  const hue = e < 5 ? 145 - (145 - 35) * (e / 5) : 35 - Math.min(1, (e - 5) / 7) * 35;
  const alpha = Math.min(0.16, 0.04 + e * 0.012);
  return `oklch(0.7 0.16 ${hue} / ${alpha})`;
}

export function errorLineColor(errorAbs: number | null | undefined): string {
  if (errorAbs === null || errorAbs === undefined || !Number.isFinite(errorAbs)) {
    return "hsl(var(--muted-foreground))";
  }
  const clamped = Math.min(15, Math.abs(errorAbs));
  if (clamped < 5) {
    const t = clamped / 5;
    return `oklch(${0.62 + (0.75 - 0.62) * t} ${0.16 + (0.18 - 0.16) * t} ${145 - (145 - 75) * t})`;
  }
  const t = Math.min(1, (clamped - 5) / 7);
  return `oklch(${0.75 - (0.75 - 0.55) * t} ${0.18 + (0.2 - 0.18) * t} ${75 - (75 - 25) * t})`;
}
